import axios from 'axios';
import { useAppState } from '../redux';
import { useQuery } from 'react-query';
import { PricingVersion } from '../../components/GlobalJobMatching/GlobalJobMatchingVersioning/types/versions';
import { QueryKeys } from '../../constants/query-keys';

export const usePricingVersions = () => {
  const appState = useAppState()
  const { csrf_timestamp, csrf_token, masterAccountId } = appState.session

  const getPricingVersions = async (): Promise<PricingVersion[]> => {
    const response = await axios.get(`/cms/api/accounts/${masterAccountId}/global-job-pricing/versions?csrf_token=${csrf_token}&csrf_timestamp=${csrf_timestamp}`)
    return response.data?.data || []
  }

  const query = useQuery([QueryKeys.GLO_JAM_PRICING_VERSIONS], getPricingVersions)

  return query
}
